/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Drop_Out_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "You won't be seated in later rounds. Your scores so far are kept. You can check back in to undo it." |
*
* @param {Tournament_Drop_Out_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_drop_out_confirm_body = /** @type {((inputs?: Tournament_Drop_Out_Confirm_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Drop_Out_Confirm_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ne serez plus placé aux rondes suivantes. Vos scores sont conservés. Vous pouvez pointer à nouveau pour annuler.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se le sentará en las rondas siguientes. Sus resultados se conservan. Puede volver a hacer el check-in para deshacerlo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você não será mais colocado nas próximas rodadas. Seus resultados ficam. Você pode fazer o check-in de novo para desfazer.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non sarai più messo a sedere nei round successivi. I tuoi punteggi restano. Puoi rifare il check-in per annullare.")
	return /** @type {LocalizedString} */ ("You won't be seated in later rounds. Your scores so far are kept. You can check back in to undo it.")
});